<ul [stacked-navigation]="data"></ul>
